module.exports = __webpack_public_path__ + "img/tank-base-3.2df69bee.png";